var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.876816 5.23626C0.875 5.55244 0.875 5.88975 0.875 6.25V11.75C0.875 14.5784 0.875 15.9926 1.75368 16.8713C2.63236 17.75 4.04657 17.75 6.875 17.75H12.125C14.9534 17.75 16.3676 17.75 17.2463 16.8713C18.125 15.9926 18.125 14.5784 18.125 11.75V6.25C18.125 5.88975 18.125 5.55244 18.1232 5.23626L10.6735 10.6346C9.97343 11.1419 9.02657 11.1419 8.32645 10.6346L0.876816 5.23626ZM0.978666 3.00522C1.1476 3.02267 1.31436 3.08343 1.46178 3.19025L9.5 9.01505L17.5382 3.19025C17.6856 3.08343 17.8524 3.02267 18.0213 3.00522C17.9136 2.16317 17.694 1.5764 17.2463 1.12868C16.3676 0.25 14.9534 0.25 12.125 0.25H6.875C4.04657 0.25 2.63236 0.25 1.75368 1.12868C1.30596 1.5764 1.08637 2.16317 0.978666 3.00522Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5c31b8b33a3cc3d185d220289e06d013.svg";
export { ForwardRef as ReactComponent };